/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';
import type {
  AssessmentsAccumulationMappingsResponse,
  AssessmentsComparisonDeleteResponse,
  AssessmentsComparisonDetailResponse,
  AssessmentsOptionsResponse,
  IdResponse,
  PagedAssessmentsComparisonListResponse,
  SuccessResponse,
} from './model';
import { AssessmentsComparisonStatus } from './model';

export const getGetAssessmentsComparisonsResponseMock =
  (): PagedAssessmentsComparisonListResponse => ({
    ...{ count: faker.number.int({ min: undefined, max: undefined }) },
    ...{
      items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          id: faker.string.uuid(),
          name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          status: faker.helpers.arrayElement(Object.values(AssessmentsComparisonStatus)),
          base_euc_import_master_id: faker.string.uuid(),
          compared_euc_import_master_id: faker.string.uuid(),
          base_fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
          compared_fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
        }),
      ),
    },
  });

export const getCreateAssessmentsComparisonResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetAssessmentsComparisonResponseMock = (): AssessmentsComparisonDetailResponse => ({
  id: '04000001-0000-0000-0000-000000000001',
  status: 'idle',
  base_fiscal_year: 2024,
  base_file_name: '2024年度_基準.csv',
  compared_fiscal_year: 2023,
  compared_file_name: '2023年度_比較.csv',
  memo: 'メモ',
  created_by: { id: '22222222-2222-2222-2222-222222222222', name: 'テストユーザー' },
  projects: [
    {
      id: '04100001-0000-0000-0000-000000000001',
      assessments_comparison_id: '04000001-0000-0000-0000-000000000001',
      tenant_id: '11111111-1111-1111-1111-111111111111',
      organization_code: '001',
      organization_name: '総務部',
      accounting_type_code: '01',
      accounting_type_name: '一般会計',
      kan: {
        id: '00000002-0000-0000-0000-000000000002',
        accounting_type_id: '17cd0e90-8acc-4632-9c77-fccd1c4f0d99',
        code: '02',
        name: '総務費',
      },
      ko: {
        id: '00020100-0000-0000-0000-000000020100',
        kan_id: '00000002-0000-0000-0000-000000000002',
        code: '01',
        name: '総務管理費',
      },
      moku: {
        id: '00020106-0000-0000-0000-000002010006',
        ko_id: '00020100-0000-0000-0000-000000020100',
        code: '06',
        name: '企画費',
      },
      project_category1_code: '001',
      project_category1_name: '総合計画推進事業',
      project_category2_code: '',
      project_category2_name: '',
      project_category3_code: '',
      project_category3_name: '',
      project_code: '001',
      project_name: '総合計画策定事業',
      memo: '総合計画策定に係る経費',
      setsus: [
        {
          id: '04200002-0000-0000-0000-000000000002',
          setsu_code: '13',
          setsu_name: '委託料',
          base_amount: 15000000,
          compared_amount: 17400000,
          difference_amount: 2400000,
          memo: '計画策定業務委託',
          saisetsus: [
            {
              id: '04300002-0000-0000-0000-000000000002',
              saisetsu_code: '01',
              saisetsu_name: '業務委託料',
              base_amount: 15000000,
              compared_amount: 17400000,
              difference_amount: 2400000,
              memo: '総合計画策定業務委託',
              saisaisetsus: [
                {
                  id: '04400001-0000-0000-0000-000000000001',
                  saisaisetsu_code: '01',
                  saisaisetsu_name: '計画策定委託',
                  base_amount: 15000000,
                  compared_amount: 17400000,
                  difference_amount: 2400000,
                  memo: '総合計画策定業務委託',
                  accumulation: {
                    id: '04500001-0000-0000-0000-000000000001',
                    bases: [
                      {
                        id: '04600001-0000-0000-0000-000000000001',
                        description: '基本設計業務',
                        amount: 8000000,
                      },
                      {
                        id: '04600002-0000-0000-0000-000000000002',
                        description: '詳細設計業務',
                        amount: 7000000,
                      },
                    ],
                    compareds: [
                      {
                        id: '04700001-0000-0000-0000-000000000001',
                        description: '基本設計業務',
                        amount: 9000000,
                      },
                      {
                        id: '04700002-0000-0000-0000-000000000002',
                        description: '詳細設計業務',
                        amount: 8400000,
                      },
                    ],
                    mappings: [
                      {
                        id: '04800001-0000-0000-0000-000000000001',
                        base_description: '基本設計業務',
                        compared_description: '基本設計業務',
                        amount_difference_type: 'increased',
                        base_total_amount: 8000000,
                        compared_total_amount: 9000000,
                        difference_amount: 1000000,
                      },
                      {
                        id: '04800002-0000-0000-0000-000000000002',
                        base_description: '詳細設計業務',
                        compared_description: '詳細設計業務',
                        amount_difference_type: 'increased',
                        base_total_amount: 7000000,
                        compared_total_amount: 8400000,
                        difference_amount: 1400000,
                      },
                    ],
                    accumulation_tags: [],
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

export const getPatchAssessmentsComparisonResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteAssessmentsComparisonResponseMock =
  (): AssessmentsComparisonDeleteResponse => ({ success: true });

export const getCreateAssessmentsAccumulationMappingResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetAssessmentsAccumulationMappingsResponseMock =
  (): AssessmentsAccumulationMappingsResponse => ({
    assessments_accumulation_id: '04500001-0000-0000-0000-000000000001',
    base_fiscal_year: 2023,
    compared_fiscal_year: 2024,
    accounting_type: {
      id: '17cd0e90-8acc-4632-9c77-fccd1c4f0d99',
      code: '01',
      name: '一般会計',
      year: 2023,
    },
    kan: {
      id: '00000002-0000-0000-0000-000000000002',
      accounting_type_id: '17cd0e90-8acc-4632-9c77-fccd1c4f0d99',
      code: '02',
      name: '総務費',
    },
    ko: {
      id: '00020100-0000-0000-0000-000000020100',
      kan_id: '00000002-0000-0000-0000-000000000002',
      code: '01',
      name: '総務管理費',
    },
    moku: {
      id: '00020106-0000-0000-0000-000002010006',
      ko_id: '00020100-0000-0000-0000-000000020100',
      code: '06',
      name: '企画費',
    },
    project_code: '001',
    project_name: '総合計画策定事業',
    project_category1_code: '13',
    project_category1_name: '委託料',
    project_category2_code: '01',
    project_category2_name: '業務委託料',
    project_category3_code: '01',
    project_category3_name: '計画策定委託',
    mappings: [
      {
        id: '04800001-0000-0000-0000-000000000001',
        base_description: '基本設計業務',
        compared_description: '基本設計業務',
        amount_difference_type: 'increased',
        base_total_amount: 8000000,
        compared_total_amount: 9000000,
        difference_amount: 1000000,
      },
      {
        id: '04800002-0000-0000-0000-000000000002',
        base_description: '詳細設計業務',
        compared_description: '詳細設計業務',
        amount_difference_type: 'increased',
        base_total_amount: 7000000,
        compared_total_amount: 8400000,
        difference_amount: 1400000,
      },
    ],
    bases: [
      { id: '04600001-0000-0000-0000-000000000001', description: '基本設計業務', amount: 8000000 },
      { id: '04600002-0000-0000-0000-000000000002', description: '詳細設計業務', amount: 7000000 },
    ],
    compareds: [
      { id: '04700001-0000-0000-0000-000000000001', description: '基本設計業務', amount: 9000000 },
      { id: '04700002-0000-0000-0000-000000000002', description: '詳細設計業務', amount: 8400000 },
    ],
    comment: 'AIからのコメント',
    memo: 'メモ',
    accumulation_tags: [{ id: '55555555-5555-5555-5555-555555555551', name: '重点施策' }],
  });

export const getPatchAssessmentsAccumulationMappingResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetAssessmentsOptionsResponseMock = (): AssessmentsOptionsResponse => ({
  accumulation_tags: [
    { id: '55555555-5555-5555-5555-555555555551', name: '重点施策' },
    { id: '55555555-5555-5555-5555-555555555552', name: 'デジタル化' },
  ],
});

export const getCreateAccumulationTagResponseMock = (
  overrideResponse: Partial<IdResponse> = {},
): IdResponse => ({ id: faker.string.uuid(), ...overrideResponse });

export const getUpdateAccumulationTagResponseMock = (): SuccessResponse => ({ success: true });

export const getDeleteAccumulationTagResponseMock = (): SuccessResponse => ({ success: true });

export const getCreateAccumulationTagAccumulationResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getDeleteAccumulationTagAccumulationResponseMock = (): SuccessResponse => ({
  success: true,
});

export const getGetAssessmentsComparisonsMockHandler = (
  overrideResponse?:
    | PagedAssessmentsComparisonListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<PagedAssessmentsComparisonListResponse>
        | PagedAssessmentsComparisonListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/assessments/comparisons',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAssessmentsComparisonsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateAssessmentsComparisonMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/assessments/comparisons',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateAssessmentsComparisonResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetAssessmentsComparisonMockHandler = (
  overrideResponse?:
    | AssessmentsComparisonDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AssessmentsComparisonDetailResponse> | AssessmentsComparisonDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/assessments/comparisons/:comparisonId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAssessmentsComparisonResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchAssessmentsComparisonMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/assessments/comparisons/:comparisonId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchAssessmentsComparisonResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteAssessmentsComparisonMockHandler = (
  overrideResponse?:
    | AssessmentsComparisonDeleteResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<AssessmentsComparisonDeleteResponse> | AssessmentsComparisonDeleteResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/assessments/comparisons/:comparisonId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteAssessmentsComparisonResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateAssessmentsAccumulationMappingMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/assessments/comparisons/:comparisonId/mappings',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateAssessmentsAccumulationMappingResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetAssessmentsAccumulationMappingsMockHandler = (
  overrideResponse?:
    | AssessmentsAccumulationMappingsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<AssessmentsAccumulationMappingsResponse>
        | AssessmentsAccumulationMappingsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/assessments/accumulations/:assessmentsAccumulationId/mappings',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAssessmentsAccumulationMappingsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getPatchAssessmentsAccumulationMappingMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/assessments/accumulations/:assessmentsAccumulationId/mappings',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPatchAssessmentsAccumulationMappingResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetAssessmentsOptionsMockHandler = (
  overrideResponse?:
    | AssessmentsOptionsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AssessmentsOptionsResponse> | AssessmentsOptionsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/assessments/options',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetAssessmentsOptionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateAccumulationTagMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/assessments/accumulation-tags',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateAccumulationTagResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateAccumulationTagMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.put(
    '*/assessments/accumulation-tags/:accumulationTagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateAccumulationTagResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteAccumulationTagMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/assessments/accumulation-tags/:accumulationTagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteAccumulationTagResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateAccumulationTagAccumulationMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/assessments/accumulations/:assessmentsAccumulationId/tags/:accumulationTagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateAccumulationTagAccumulationResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteAccumulationTagAccumulationMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/assessments/accumulations/:assessmentsAccumulationId/tags/:accumulationTagId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteAccumulationTagAccumulationResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getGetAssessmentsComparisonsMockHandler(),
  getCreateAssessmentsComparisonMockHandler(),
  getGetAssessmentsComparisonMockHandler(),
  getPatchAssessmentsComparisonMockHandler(),
  getDeleteAssessmentsComparisonMockHandler(),
  getCreateAssessmentsAccumulationMappingMockHandler(),
  getGetAssessmentsAccumulationMappingsMockHandler(),
  getPatchAssessmentsAccumulationMappingMockHandler(),
  getGetAssessmentsOptionsMockHandler(),
  getCreateAccumulationTagMockHandler(),
  getUpdateAccumulationTagMockHandler(),
  getDeleteAccumulationTagMockHandler(),
  getCreateAccumulationTagAccumulationMockHandler(),
  getDeleteAccumulationTagAccumulationMockHandler(),
];
